import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { QueryParams } from '../../models/http.models';

@Injectable({
  providedIn: 'root',
})
export class ValidationsExportsResource {
  constructor(private http: HttpClient) {}

  get(params?: QueryParams): Observable<any> {
    return this.http.get<any>(`${process.env.API_URL}/validations_export`, { params });
  }
}
